
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import Layout from '@/components/layout/Layout';
import { toast } from 'sonner';

const Index: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    // Redirect authenticated users to the dashboard
    const checkAuth = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Error checking auth:", error);
          setError(error.message);
          toast.error("Authentication error", {
            description: error.message,
          });
          return;
        }
        
        if (data.session) {
          console.log("User authenticated, redirecting to dashboard");
          navigate('/dashboard');
        } else {
          // If not authenticated, redirect to landing page
          console.log("User not authenticated, redirecting to landing");
          navigate('/');
        }
      } catch (err) {
        console.error("Unexpected error during auth check:", err);
        setError("An unexpected error occurred");
        toast.error("Navigation error", {
          description: "Unable to determine login status. Please try again.",
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, [navigate]);
  
  if (isLoading) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-16 flex items-center justify-center min-h-[60vh]">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
            <p className="text-lg text-muted-foreground">
              Checking your credentials...
            </p>
          </div>
        </div>
      </Layout>
    );
  }
  
  if (error) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-3xl font-bold text-red-500">Something went wrong</h1>
            <p className="mt-4 text-lg text-muted-foreground">
              {error}
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="mt-6 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      </Layout>
    );
  }
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-bold">Welcome to Muso360</h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Redirecting you to the right place...
          </p>
          <div className="mt-6 animate-pulse flex justify-center">
            <div className="h-2 w-24 bg-primary/40 rounded"></div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
